export const red = "red";
export const white = "white";

export const options = [
  {
    label: "JAG GÅR 1 075 M",
    confirmation: "Vill du registrera en sträcka på 1 075 M?",
    description: "( Motsvarar 1/4 av en parad )",
    value: 1075
  },
  {
    label: "JAG GÅR 2 150 M",
    confirmation: "Vill du registrera en sträcka på 2 150 M?",
    description: "( Motsvarar 1/2 parad )",
    value: 2150
  },
  {
    label: "JAG GÅR 3 225 M",
    confirmation: "Vill du registrera en sträcka på 3 225 M?",
    description: "( Motsvarar 3/4 av en parad )",
    value: 3225
  },
  {
    label: "JAG GÅR 4 300 M",
    confirmation: "Vill du registrera en sträcka på 4 300 M?",
    description: "( Motsvarar en parad )",
    value: 4300
  }
];
